export const mapAppVersionToDataTable = (data) => {
  let result = data.map((item) => ({
    ...item,
    numOfGroup: item.releaseAppVersions?.length || 0,
    osName: item.operatingSystem?.name,
  }));

  return result;
};

export const MODE_RELEASE = {
  releaseOnGroup: "releaseOnGroup",
  releaseMass: "releaseMass",
};

export const appVersionColumns = [
  { key: "name", label: "Name", align: "center" },
  { key: "versionName", label: "Version Name", align: "center" },
  { key: "versionCode", label: "Version Code", align: "center" },
  { key: "osName", label: "OS Name", align: "center" },
  { key: "numOfGroup", label: "Num Of Group", align: "center" },
];
